// extracted by mini-css-extract-plugin
export var cyan = "Select-module--cyan--2QmCq";
export var icon = "Select-module--icon--qb2OS";
export var item = "Select-module--item--PkVdV";
export var itemSpacer = "Select-module--itemSpacer--SMBFi";
export var left = "Select-module--left--24lMd";
export var red = "Select-module--red--oe-oK";
export var right = "Select-module--right--V1fHR";
export var root = "Select-module--root--XCbvO";
export var seeMore = "Select-module--seeMore--bwiuf";
export var select = "Select-module--select--8JJ5P";
export var selectContainer = "Select-module--selectContainer--zOEFi";
export var spacer = "Select-module--spacer----oRw";
export var title = "Select-module--title--F2Y5o";